export default __webpack_public_path__ + "static/media/download.dbcd9306.png";